import React, { useState } from 'react';
import { Col } from 'antd';
import './index.less';
import { useSelector } from 'react-redux';
import Table from './Table';

const Tenants = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(true);

  return (
    <Col span={24}>
      <Table canUpdate={canUpdate} canDelete={true} />
    </Col>
  );
};

export default Tenants;
